export const INFO_BLOCK_ITEMS_PER_PAGE = 10;
